/**
 * @viewlift/shaka resolves playback from videoAssets.dash / .hls only.
 * When the API only returns progressive MP4 renditions under `mpeg`, map the best URL to `hls`
 * so Shaka can load it (mime is inferred when not .m3u8/.mpd).
 */
const RENDITION_PRIORITY = ['_1080p', '_720p', '_480p', '_360p'];
function pickBestMpegUrl(mpeg) {
    var _a;
    if (!Array.isArray(mpeg) || mpeg.length === 0)
        return null;
    for (const label of RENDITION_PRIORITY) {
        const hit = mpeg.find((m) => (m === null || m === void 0 ? void 0 : m.url) &&
            (m.rendition_value === label || String(m.rendition_value || '').includes(label)));
        if (hit === null || hit === void 0 ? void 0 : hit.url)
            return hit.url;
    }
    const first = mpeg.find((m) => m === null || m === void 0 ? void 0 : m.url);
    return (_a = first === null || first === void 0 ? void 0 : first.url) !== null && _a !== void 0 ? _a : null;
}
function isEmptyStream(u) {
    return u == null || u === '' || (typeof u === 'object' && !Array.isArray(u) && !u.url);
}
export function normalizeVideoAssetsForShaka(videoAssets) {
    if (!videoAssets || typeof videoAssets !== 'object')
        return;
    const va = videoAssets;
    const dash = va.dash;
    const hls = va.hls;
    const mpeg = va.mpeg;
    const hasDash = !isEmptyStream(dash);
    const hasHls = !isEmptyStream(hls);
    if (hasDash || hasHls)
        return;
    const url = pickBestMpegUrl(mpeg);
    if (url) {
        va.hls = url;
    }
}
export function normalizeEntitlementVideoInPayload(data) {
    var _a;
    if (!data || typeof data !== 'object')
        return;
    const d = data;
    const video = d.video;
    if ((_a = video === null || video === void 0 ? void 0 : video.streamingInfo) === null || _a === void 0 ? void 0 : _a.videoAssets) {
        normalizeVideoAssetsForShaka(video.streamingInfo.videoAssets);
    }
    const entitlements = d.entitlements;
    if (Array.isArray(entitlements)) {
        entitlements.forEach((e) => {
            var _a;
            const v = e === null || e === void 0 ? void 0 : e.video;
            if ((_a = v === null || v === void 0 ? void 0 : v.streamingInfo) === null || _a === void 0 ? void 0 : _a.videoAssets) {
                normalizeVideoAssetsForShaka(v.streamingInfo.videoAssets);
            }
        });
    }
}
